import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faSchool,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history" className="timeline-section">
      <div className="items-container">
        <h1 className="section-title">My Journey</h1>
        <VerticalTimeline lineColor="#5000ca" animate={false}>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Present"
            dateClassName="timeline-date"
            contentStyle={{ 
              background: 'var(--card-bg)', 
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 4px 16px var(--card-shadow)',
              borderRadius: '8px'
            }}
            contentArrowStyle={{ borderRight: '7px solid var(--border-color)' }}
            iconStyle={{ 
              background: "#5000ca", 
              color: "#ffffff",
              boxShadow: '0 0 0 4px var(--border-color)'
            }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Full Stack Intern
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Tirana, Albania
            </h4>
            <div className="timeline-tags">
              <span>React</span>
              <span>TypeScript</span>
              <span>Redux</span>
              <span>API Development</span>
              <span>User Experience</span>
              <span>State Management</span>
            </div>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="2024 - 2025"
            dateClassName="timeline-date"
            contentStyle={{ 
              background: 'var(--card-bg)', 
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 4px 16px var(--card-shadow)',
              borderRadius: '8px'
            }}
            contentArrowStyle={{ borderRight: '7px solid var(--border-color)' }}
            iconStyle={{ 
              background: "#5000ca", 
              color: "#ffffff",
              boxShadow: '0 0 0 4px var(--border-color)'
            }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">
              Exchange studies - Malardalens University
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Västerås, Sweden
            </h4>
            <div className="timeline-tags">
              <span>IoT</span>
              <span>Cloud Computing</span>
              <span>Security</span>
              <span>DevOps</span>
              <span>Networking</span>
              <span>Communication Skills</span>
            </div>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="2022 - 2025"
            dateClassName="timeline-date"
            contentStyle={{ 
              background: 'var(--card-bg)', 
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 4px 16px var(--card-shadow)',
              borderRadius: '8px'
            }}
            contentArrowStyle={{ borderRight: '7px solid var(--border-color)' }}
            iconStyle={{ 
              background: "#5000ca", 
              color: "#ffffff",
              boxShadow: '0 0 0 4px var(--border-color)'
            }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">
              Bachelor - European University of Albania
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Tirana, Albania
            </h4>
            <div className="timeline-tags">
              <span>Frontend</span>
              <span>Backend</span>
              <span>Mobile Dev</span>
              <span>ML/AI</span>
              <span>Algorithms</span>
              <span>Data Structures</span>
            </div>
          </VerticalTimelineElement>
          
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="2018 - 2022"
            dateClassName="timeline-date"
            contentStyle={{ 
              background: 'var(--card-bg)', 
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 4px 16px var(--card-shadow)',
              borderRadius: '8px'
            }}
            contentArrowStyle={{ borderRight: '7px solid var(--border-color)' }}
            iconStyle={{ 
              background: "#5000ca", 
              color: "#ffffff",
              boxShadow: '0 0 0 4px var(--border-color)'
            }}
            icon={<FontAwesomeIcon icon={faSchool} />}
          >
            <h3 className="vertical-timeline-element-title">
              Dual Studies School Kolin Gjoka
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Lezhe, Albania
            </h4>
            <div className="timeline-tags">
              <span>Web Dev</span>
              <span>Databases</span>
              <span>PHP</span>
              <span>JavaScript</span>
            </div>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
